import { string, table } from "@rocicorp/zero";
import { coreFields } from "./shared";

export const projectResourceLink = table("projectResourceLinks")
	.from("project_resource_links")
	.columns({
		...coreFields,
		projectId: string().from("project_id"),
		ticketId: string().from("ticket_id").optional(),
		linkId: string().from("link_id"),
		orgId: string().from("org_id"),
	})
	.primaryKey("id");
